import { Card, Typography } from "@mui/material";

interface Props {
  errorData: Record<string, string>;
}

export const ErrorDisplay = ({ errorData }: Props) => {
  return (
    <div>
      <Typography>
        There was an error, please copy the data and forward it to developers
      </Typography>
      <Card sx={{ p: "16px" }}>
        <pre style={{ whiteSpace: "break-spaces" }}>
          {JSON.stringify(errorData, null, 2)}
        </pre>
      </Card>
    </div>
  );
};
